import _regeneratorRuntime from "@babel/runtime-corejs2/regenerator";
import _asyncToGenerator from "@babel/runtime-corejs2/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime-corejs2/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs2/helpers/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime-corejs2/helpers/assertThisInitialized";
import _inherits from "@babel/runtime-corejs2/helpers/inherits";
import _defineProperty from "@babel/runtime-corejs2/helpers/defineProperty";
import { ErrorTypes, StateTypes, WelcomeMessagesFlowInterface } from '@central-products/welcome-messages-flow-interface';
import MessageBusTransport from '@central-products/message-transport-bus';

var WelcomeMessagesFlow =
/*#__PURE__*/
function (_WelcomeMessagesFlowI) {
  _inherits(WelcomeMessagesFlow, _WelcomeMessagesFlowI);

  function WelcomeMessagesFlow(_ref) {
    var _this;

    var transport = _ref.transport;

    _classCallCheck(this, WelcomeMessagesFlow);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(WelcomeMessagesFlow).call(this));

    _defineProperty(_assertThisInitialized(_this), "state", StateTypes.NONE);

    _defineProperty(_assertThisInitialized(_this), "stateChangedCallback", void 0);

    (transport || MessageBusTransport.getInstance()).bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(WelcomeMessagesFlow, [{
    key: "start",
    value: function () {
      var _start = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(action) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(this.state !== StateTypes.NONE)) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return", {
                  error: ErrorTypes.INVALID_STATE
                });

              case 2:
                this.changeState(StateTypes.UI_REQUESTED, action);
                return _context.abrupt("return", {});

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function start(_x) {
        return _start.apply(this, arguments);
      }

      return start;
    }()
  }, {
    key: "cancel",
    value: function () {
      var _cancel = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(this.state === StateTypes.NONE)) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return", {
                  error: ErrorTypes.INVALID_STATE
                });

              case 2:
                this.changeState(StateTypes.NONE);
                return _context2.abrupt("return", {});

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function cancel() {
        return _cancel.apply(this, arguments);
      }

      return cancel;
    }()
  }, {
    key: "uiDisplayed",
    value: function () {
      var _uiDisplayed = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(this.state !== StateTypes.UI_REQUESTED)) {
                  _context3.next = 2;
                  break;
                }

                return _context3.abrupt("return", {
                  error: ErrorTypes.INVALID_STATE
                });

              case 2:
                this.changeState(StateTypes.UI_DISPLAYED);
                return _context3.abrupt("return", {});

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function uiDisplayed() {
        return _uiDisplayed.apply(this, arguments);
      }

      return uiDisplayed;
    }()
  }, {
    key: "onStateChanged",
    value: function onStateChanged(callback) {
      this.stateChangedCallback = callback; // tslint:disable-next-line:no-empty

      return function () {};
    }
  }, {
    key: "changeState",
    value: function changeState(state, action) {
      this.state = state;

      if (typeof this.stateChangedCallback === 'function') {
        this.stateChangedCallback({
          state: state,
          action: action
        });
      }
    }
  }]);

  return WelcomeMessagesFlow;
}(WelcomeMessagesFlowInterface);

export { WelcomeMessagesFlow as default };
//# sourceMappingURL=WelcomeMessagesFlow.js.map